import Vue from 'vue'
import Vuex from 'vuex'
import { fixedRoutes } from '@/router'
import { asyncRoutes } from '@/router/asyncRoutes'
import { getInfor, getSignature } from '@/services/user'
import {
  removeToken, removeTeamCode, getAgentCode, getAgentName, getLoginInfos, getTeamName,
  getTeamRole, getTeamStatus, getAgentStatus, removeAgentCode, removeLoginInfos,
  removeTeamName, getConversionPath, getTeamCode, isThirdParty, isB2C, isCampus, isB2COrCampus
} from '@/utils/auth'

Vue.use(Vuex)

function hasPermission(roles, route) {
  if (route.meta && route.meta.codes) {
    return roles.some(role => route.meta.codes.includes(role))
  } else {
    return true
  }
}

function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const store = new Vuex.Store({
  state: {
    roles: [],
    name: '',
    routes: fixedRoutes,
    uploadImages: {},
    uploadImagesDetail: {},
    uploadImagesArr: [],
    cachedViews: [],
    addRouters: [],
    permissionList: [],
    staff: {},
    user: {},
    ossParams: {},
    renewShow: false,
    repeatBuy: false,
    manualOrder: false,
    template: [],
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_ROLES: (state, roles, permissionList) => {
      state.roles = roles
      state.permissionList = permissionList
    },
    SET_UPLOAD_IMG: (state, images) => {
      state.uploadImages = { ...images }
    },
    SET_UPLOAD_IMG_DETAIL: (state, images) => {
      state.uploadImagesDetail = { ...images }
    },
    SET_UPLOAD_IMG_ARR: (state, images) => {
      state.uploadImagesArr = images
    },
    REMOVE_UPLOAD_IMG: (state) => {
      state.uploadImages = {}
    },
    SET_ROUTES: (state, routes) => {
      state.addRouters = routes
      state.routes = fixedRoutes.concat(routes)
    },
    SET_STAFF: (state, staff) => {
      state.staff = staff
    },
    SET_OSSPARAMS: (state, params) => {
      state.ossParams = params
    },
    SET_RENEWSHOUW: (state, params) => {
      state.renewShow = params
    },
    SET_LINKCREATE: (state, params) => {
      state.linkCreate = params
    },
    SET_REPEATBUY: (state, params) => {
      state.repeatBuy = params
    },
    SET_MANUALORDER: (state, params) => {
      state.manualOrder = params
    },
    SET_TEMPLATE: (state, params) => {
      state.template = params
    }
  },
  // 下面这两个都是全局的
  actions: {
    getInfo({ commit, state }) {
      return new Promise((resolve) => {
        const staffVo = {
          id: getAgentCode(),
          name: getAgentName(),
          loginInfos: getLoginInfos(),
          teamName: getTeamName()
        }
        commit('SET_STAFF', staffVo)
        // 判断菜单权限
        if (getTeamCode()) {
          getInfor(getTeamCode()).then(response => {
            if (response.data && response.data.errCode === 0) {
              const { courseOrderShow, renewShow, linkCreate, repeatBuy, manualOrder, sms, showQuarter, thirdOrderUpload, aiImport } = response.data.data
              //! 数据权限需要单独处理 设置code
              const teamRole = getTeamRole() && Number(getTeamRole());
              const meunName = courseOrderShow ? 'official' : null // 精品课菜单名称
              const smsMeunName = sms ? 'sms' : null
              const showQuarterMeun = showQuarter ? 'showQuarter' : null
              const thirdPartyOrder = isThirdParty() ? 'thirdPartyOrder' : null
              const timeChannel = isThirdParty() ? null : 'timeChannel'
              const timeOrder = isThirdParty() ? null : 'timeOrder'
              const thirdOrderUploadMeun = thirdOrderUpload ? 'thirdOrderUpload' : null
              const _aiImport = !aiImport || isThirdParty() ? null : 'aiImport'
              const B2C_PWcourse_Data = isB2COrCampus() ? 'B2C_PWcourse_Data' : null
              const member = isB2COrCampus() && teamRole !== 1 ? null : 'member'
              // 隐藏BTC订单中心和时间维度报表下所有报表
              const basePermission = isB2COrCampus() ? [`${smsMeunName}`, 'links', 'promotion'] : ['order', `${meunName}`, `${smsMeunName}`, `${showQuarterMeun}`, `${thirdOrderUploadMeun}`, thirdPartyOrder, _aiImport, 'links', 'promotion']
              const timeOrgList = isB2COrCampus() ? [member] : ['timeOrg', timeOrder, timeChannel, 'timeStaff', member]
              commit('SET_RENEWSHOUW', renewShow)
              commit('SET_LINKCREATE', linkCreate)
              commit('SET_REPEATBUY', repeatBuy)
              commit('SET_MANUALORDER', manualOrder)
              commit('SET_TEMPLATE', response.data.data)
              /*
                agentCode： 代理商标识，相当于userId
                teamStatus: 团队是否启用 0启用状态 1封禁,
                agentStatus: 代理商状态：0正常 1停用
                conversionPath：团队转化路径 1 体验课到精品课  2 公益课到体验课到精品课
                teamRole：团队角色 0团员 1队长(创建人) 2管理员
              */
              if (getAgentCode() && Number(getTeamStatus()) === 0 && Number(getAgentStatus()) === 0) { // 0 启用状态
                const permissionCodeList = getTeamRole() && (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) // teamRole 1, 2创建者和管理员
                  ? getConversionPath() && Number(getConversionPath()) === 2 // conversionPath : 2,公益课-》体验课-》精品课
                    ? [...basePermission, ...timeOrgList, B2C_PWcourse_Data]
                    : [...basePermission, ...timeOrgList] // conversionPath : 1,体验课-》精品课
                  : basePermission
                commit('SET_ROLES', permissionCodeList, [])
                resolve(permissionCodeList)
              } else {
                removeToken()
                removeTeamCode()
                removeAgentCode()
                removeLoginInfos()
                removeTeamName()
                commit('SET_ROLES', [], [])
                window.location.href = window.location.origin + '/login'
              }
            }
          })
        }
      })
    },
    handleRoutes({ commit }, { roles }) {
      return new Promise((resolve) => {
        let accessedRoutes = []
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
        // 再次筛选最外层如果存在children, 但是children 为空数组，那么也要从里面剔除掉，（只遍历一遍）
        const new_accessedRoutes = []
        accessedRoutes.map((item) => {
          if (item.children && item.children.length === 0) {
            // delete item.children
          } else {
            new_accessedRoutes.push(item)
          }
        })
        commit('SET_ROUTES', new_accessedRoutes)
        resolve()
      })
    },
    resetToken({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        removeTeamCode()
        removeLoginInfos()
        removeTeamName()
        resolve()
      })
    },
    addUplaodImages({ commit }, imgUrlObj) {
      return new Promise((resolve) => {
        commit('SET_UPLOAD_IMG', imgUrlObj)
        resolve()
      })
    },
    addUplaodImagesDetail({ commit }, imgUrlObj) {
      return new Promise((resolve) => {
        commit('SET_UPLOAD_IMG_DETAIL', imgUrlObj)
        resolve()
      })
    },
    addUplaodImagesArr({ commit }, imgUrlObj) {
      return new Promise((resolve) => {
        commit('SET_UPLOAD_IMG_ARR', imgUrlObj)
        resolve()
      })
    },
    removeUploadImages({ commit }) {
      return new Promise((resolve) => {
        commit('REMOVE_UPLOAD_IMG')
        resolve()
      })
    },
    getOssSignature({ commit, state }) {
      return new Promise((resolve) => {
        const dataFunc = () => {
          if (state.ossParams && Object.keys(state.ossParams).length > 0) {
            if (state.ossParams.dataLoading) {
              setTimeout(dataFunc, 1000);
            } else {
              resolve(state.ossParams);
            }
          } else {
            commit("SET_OSSPARAMS", { dataLoading: true });
            getSignature().then(resData => {
              commit("SET_OSSPARAMS", resData.data.data)
              resolve(resData.data.data);
            })
          }
        }
        dataFunc();
      })
    }
  },
  getters: {
    roles: state => state.roles,
    permissionList: state => state.permissionList,
    name: state => state.name,
    routesConfig: state => state.routes,
    uploadImages: state => state.uploadImages,
    uploadImagesDetail: state => state.uploadImagesDetail,
    uploadImagesArr: state => state.uploadImagesArr,
    addRouters: state => state.addRouters,
    staff: state => state.staff,
    user: state => state.user,
    renewShow: state => state.renewShow,
    linkCreate: state => state.linkCreate,
    repeatBuy: state => state.repeatBuy,
    manualOrder: state => state.manualOrder,
    loginInfos: state => {
      const { loginInfos } = state.staff;
      let infos = []
      try {
        infos = JSON.parse(loginInfos);
      } catch (error) {
        console.error(error);
      }
      return Array.isArray(infos) ? infos : [];
    },
    refundShow: state => state.template.refundShow,
    isSubscribe: state => state.template.isSubscribe,
    isAddedCounselorWx: state => state.template.isAddCounselorWx,
    isUnit1Attend: state => state.template.isAttend,
    isB2cClassId: state => state.template.isB2cClassId,
    isB2cSchoolId: state => state.template.isB2cSchoolId === true,
  }
})

export default store
